import { dashboardConstants } from '../_constants';
import { dashboardService } from '../_services';
import { toast } from 'react-toastify';

export const dashboardActions = {

    getMetaRespondantDetails,
    getResponseAnalytics,
    getMetaResponseAnalyticsFilter,
    getEmpFilter,
    getEmpSurveyWiseFilter,
    getSurveyResponseList,
    getClientProfile,


    createCaseStudy,
    updateCaseStudy,
    deleteCaseStudy,
    getCaseStudyList,

    getCaseStudyDetailsList,
    saveCaseStudyDetails,
    updateCaseStudyDetails,



    createRolePlay,
    updateRolePlay,
    deleteRolePlay,
    getRolePlayList,

    getRolePlayDetailsList,
    saveRolePlayDetails,
    updateRolePlayDetails,

    getInsightMailLibraryList,
    getInsightMailLibraryIntro,

    getInsightEmployeeList,
    getInsightEmployeeListV2,

    getInsightSurveyList,

    assignInsightEmpTasks,
    getInsightEmpTaskList,

    getCaseStudyDetails,
    getRolePlayDetails,
    getMailBoxDetails,
    getMeetingLinkDetails,
    saveMeetingNotes,
    getMeetingNotes,
    replyInsightMail,
    getInsightMailReply,
    saveInsightActivityTracking,
    getInsightActivityTrackingByEmpId,

    getInsightEmpTaskById,
    saveInsightEmployeeList,
    getInsightUser,

    updateReplyInsightMail,
    deleteReplyInsightMail,

    getConnectDetails,
    updateInsightMail,
    createInsightMail,
    updateAssignInsightEmpTasks,

    savePDFUpload,

    createInsightEmployee,
    updateInsightEmployee,
    deleteInsightEmployee,
    getInsightUploadsByAssignedId,
    getInsightSurveyByAssignedId,
    getInsightActivityStatus,
    saveInsightActivityApproval,
    deleteMeetingNotes,
    getInsightUploadStatus,
    saveCoachUsers,
    getCoachUsers,

    getCoachEmployeeList,
    submitCoachFeedback,
    getInsightCompetencyList,
    getInsightAllFeedbacks,

    saveInboxIntro,
    getInsightMailReplies
};

function getInsightMailReplies(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightMailReplies(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_MAIL_REPLIES_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_MAIL_REPLIES_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_MAIL_REPLIES_FAILURE, error } }
}

function saveInboxIntro(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveInboxIntro(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                    dispatch(this.getInsightMailLibraryIntro());
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_INBOX_INTRO_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_INBOX_INTRO_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_INBOX_INTRO_FAILURE, error } }
}


function getInsightAllFeedbacks(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightAllFeedbacks(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_ALL_FEEDBACKS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_ALL_FEEDBACKS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_ALL_FEEDBACKS_FAILURE, error } }
}



function getCoachEmployeeList(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getCoachEmployeeList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_COACH_EMPLOYEE_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_COACH_EMPLOYEE_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_COACH_EMPLOYEE_LIST_FAILURE, error } }
}


function getInsightCompetencyList(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightCompetencyList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_COACH_COMPETENCY_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_COACH_COMPETENCY_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_COACH_COMPETENCY_LIST_FAILURE, error } }
}


function submitCoachFeedback(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.submitCoachFeedback(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                    dispatch(this.getCoachEmployeeList(temp));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SUBMIT_COACH_FEEDBACK_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SUBMIT_COACH_FEEDBACK_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SUBMIT_COACH_FEEDBACK_FAILURE, error } }
}




function saveCoachUsers(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveCoachUsers(data)
            .then(
                dashboard => {
                    toast("Updated!")
                    dispatch(success(dashboard));
                    dispatch(this.getInsightEmployeeList(temp))
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_COACH_USERS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_COACH_USERS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_COACH_USERS_FAILURE, error } }
}
function getCoachUsers(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getCoachUsers(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_COACH_USERS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_COACH_USERS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_COACH_USERS_FAILURE, error } }
}


function getInsightUploadStatus(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightUploadStatus(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_UPLOAD_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_UPLOAD_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_UPLOAD_DETAILS_FAILURE, error } }
}



function saveInsightActivityApproval(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveInsightActivityApproval(data)
            .then(
                dashboard => {
                    // toast("Saved!")
                    dispatch(this.getInsightEmpTaskById(temp))
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_INSIGHT_ACTIVITY_APPROVAL_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_INSIGHT_ACTIVITY_APPROVAL_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_INSIGHT_ACTIVITY_APPROVAL_FAILURE, error } }
}



function getInsightActivityStatus(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightActivityStatus(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_ACTIVITY_STATUS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_ACTIVITY_STATUS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_ACTIVITY_STATUS_FAILURE, error } }
}




function getInsightSurveyByAssignedId(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightSurveyByAssignedId(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_SURVEY_ASSIGN_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_SURVEY_ASSIGN_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_SURVEY_ASSIGN_FAILURE, error } }
}





function getInsightUploadsByAssignedId(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightUploadsByAssignedId(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.INSIGHT_UPLOADS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.INSIGHT_UPLOADS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.INSIGHT_UPLOADS_FAILURE, error } }
}


function deleteInsightEmployee(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.deleteInsightEmployee(data)
            .then(
                dashboard => {
                    dispatch(this.getInsightEmployeeList(temp));
                    toast("Successfully Deleted!")
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.DELETE_INSIGHT_EMPLOYEE_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.DELETE_INSIGHT_EMPLOYEE_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.DELETE_INSIGHT_EMPLOYEE_FAILURE, error } }
}

function updateInsightEmployee(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateInsightEmployee(data)
            .then(
                dashboard => {
                    toast("Successfully Updated!")
                    dispatch(this.getInsightEmployeeList(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_INSIGHT_EMPLOYEE_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_INSIGHT_EMPLOYEE_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_INSIGHT_EMPLOYEE_FAILURE, error } }
}


function createInsightEmployee(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.createInsightEmployee(data)
            .then(
                dashboard => {
                    toast("Successfully Created!")
                    dispatch(this.getInsightEmployeeList(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.CREATE_INSIGHT_EMPLOYEE_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.CREATE_INSIGHT_EMPLOYEE_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.CREATE_INSIGHT_EMPLOYEE_FAILURE, error } }
}



function savePDFUpload(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.savePDFUpload(data)
            .then(
                dashboard => {
                    toast("Successfully Uploaded!")
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_PDF_UPLOAD_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_PDF_UPLOAD_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_PDF_UPLOAD_FAILURE, error } }
}



function updateAssignInsightEmpTasks(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateAssignInsightEmpTasks(data)
            .then(
                dashboard => {
                    toast("Successfully Updated!")
                    dispatch(this.getInsightEmpTaskList(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_ASSIGN_INSIGHT_EMP_TASK_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_ASSIGN_INSIGHT_EMP_TASK_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_ASSIGN_INSIGHT_EMP_TASK_FAILURE, error } }
}



function createInsightMail(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.createInsightMail(data)
            .then(
                dashboard => {
                    toast("Successfully Created!")
                    dispatch(this.getInsightMailLibraryList());
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.CREATE_INSIGHT_MAIL_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.CREATE_INSIGHT_MAIL_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.CREATE_INSIGHT_MAIL_FAILURE, error } }
}

function updateInsightMail(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateInsightMail(data)
            .then(
                dashboard => {
                    toast("Successfully Updated!")
                    dispatch(this.getInsightMailLibraryList());
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_INSIGHT_MAIL_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_INSIGHT_MAIL_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_INSIGHT_MAIL_FAILURE, error } }
}

function getConnectDetails(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getConnectDetails(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_CONNECT_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_CONNECT_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_CONNECT_DETAILS_FAILURE, error } }
}





function deleteReplyInsightMail(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.deleteReplyInsightMail(data)
            .then(
                dashboard => {
                    toast("Reply Deleted!")
                    dispatch(this.getInsightMailReply(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Delete Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.DELETE_REPLY_INSIGHT_MAIL_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.DELETE_REPLY_INSIGHT_MAIL_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.DELETE_REPLY_INSIGHT_MAIL_FAILURE, error } }
}


function updateReplyInsightMail(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateReplyInsightMail(data)
            .then(
                dashboard => {
                    dispatch(this.getInsightMailReply(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_REPLY_INSIGHT_MAIL_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_REPLY_INSIGHT_MAIL_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_REPLY_INSIGHT_MAIL_FAILURE, error } }
}


function getInsightUser(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightUser(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_EMPLOYEE_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_EMPLOYEE_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_EMPLOYEE_DETAILS_FAILURE, error } }
}




function saveInsightEmployeeList(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveInsightEmployeeList(data)
            .then(
                dashboard => {
                    dispatch(this.getInsightEmployeeList(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_INSIGHT_EMPLOYEE_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_INSIGHT_EMPLOYEE_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_INSIGHT_EMPLOYEE_LIST_FAILURE, error } }
}


function getInsightActivityTrackingByEmpId(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightActivityTrackingByEmpId(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_ACTIVITY_TRACKING_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_ACTIVITY_TRACKING_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_ACTIVITY_TRACKING_FAILURE, error } }
}


function saveInsightActivityTracking(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveInsightActivityTracking(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_ACTIVITY_TRACKING_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_ACTIVITY_TRACKING_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_ACTIVITY_TRACKING_FAILURE, error } }
}


function deleteMeetingNotes(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.deleteMeetingNotes(data)
            .then(
                dashboard => {
                    toast("Note Deleted!")
                    dispatch(this.getMeetingNotes({}));
                    dispatch(this.getMeetingLinkDetails({}));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Delete Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.DELETE_MEET_NOTES_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.DELETE_MEET_NOTES_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.DELETE_MEET_NOTES_FAILURE, error } }
}


function saveMeetingNotes(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveMeetingNotes(data)
            .then(
                dashboard => {
                    toast("Note Saved!")
                    dispatch(this.getMeetingNotes({}));
                    dispatch(this.getMeetingLinkDetails({}));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Save Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_MEET_NOTES_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_MEET_NOTES_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_MEET_NOTES_FAILURE, error } }
}
function getMeetingNotes(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getMeetingNotes(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_MEET_NOTES_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_MEET_NOTES_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_MEET_NOTES_FAILURE, error } }
}


function getMeetingLinkDetails(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getMeetingLinkDetails(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_MEETLINK_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_MEETLINK_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_MEETLINK_DETAILS_FAILURE, error } }
}

function getCaseStudyDetails(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getCaseStudyDetails(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_CASE_STUDY_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_CASE_STUDY_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_CASE_STUDY_DETAILS_FAILURE, error } }
}
function getRolePlayDetails(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getRolePlayDetails(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_ROLE_PLAY_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_ROLE_PLAY_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_ROLE_PLAY_DETAILS_FAILURE, error } }
}
function getMailBoxDetails(data, type) {
    return dispatch => {
        dispatch(request());
        dashboardService.getMailBoxDetails(data)
            .then(
                dashboard => {
                    if (type === "getInsightMailReply" &&
                        dashboard &&
                        dashboard.getMailBoxDetailsData &&
                        dashboard.getMailBoxDetailsData.length > 0) {
                        const mailLibInitId = dashboard.getMailBoxDetailsData[0]["id"];
                        let reqData = {
                            mailLibId: mailLibInitId
                        }
                        dispatch(this.getInsightMailReply(reqData));
                    }
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_MAIL_BOX_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_MAIL_BOX_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_MAIL_BOX_DETAILS_FAILURE, error } }
}




function assignInsightEmpTasks(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.assignInsightEmpTasks(data)
            .then(
                dashboard => {
                    toast("Successfully Assigned!")
                    dispatch(this.getInsightEmpTaskList(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.ASSIGN_INSIGHT_EMP_TASK_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.ASSIGN_INSIGHT_EMP_TASK_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.ASSIGN_INSIGHT_EMP_TASK_FAILURE, error } }
}



function getInsightEmpTaskList(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightEmpTaskList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_EMP_TASK_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_EMP_TASK_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_EMP_TASK_FAILURE, error } }
}


function getInsightEmpTaskById(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightEmpTaskById(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_EMP_TASK_ONE_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_EMP_TASK_ONE_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_EMP_TASK_ONE_FAILURE, error } }
}

function replyInsightMail(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.replyInsightMail(data)
            .then(
                dashboard => {
                    toast("Reply Saved!")
                    dispatch(this.getInsightMailReply({ mailLibId: data.mailLibId }))
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Reply Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.REPLY_INSIGHT_MAIL_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.REPLY_INSIGHT_MAIL_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.REPLY_INSIGHT_MAIL_FAILURE, error } }
}

function getInsightMailReply(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightMailReply(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_MAIL_REPLY_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_MAIL_REPLY_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_MAIL_REPLY_FAILURE, error } }
}

function getInsightSurveyList(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightSurveyList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_SURVEY_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_SURVEY_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_SURVEY_LIST_FAILURE, error } }
}

function getInsightEmployeeList(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightEmployeeList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_EMP_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_EMP_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_EMP_LIST_FAILURE, error } }
}


function getInsightEmployeeListV2(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightEmployeeList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_EMP_LIST_V2_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_EMP_LIST_V2_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_EMP_LIST_V2_FAILURE, error } }
}

function getInsightMailLibraryList(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightMailLibraryList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_MAIL_LIB_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_MAIL_LIB_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_MAIL_LIB_FAILURE, error } }
}


function getInsightMailLibraryIntro(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getInsightMailLibraryIntro(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_INSIGHT_MAIL_LIB_INTRO_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_INSIGHT_MAIL_LIB_INTRO_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_INSIGHT_MAIL_LIB_INTRO_FAILURE, error } }
}
//-------------------------------------------------------------

function createCaseStudy(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.createCaseStudy(data)
            .then(
                dashboard => {
                    toast("Case Study Created!")
                    dispatch(this.getCaseStudyList(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.CREATE_CASE_STUDY_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.CREATE_CASE_STUDY_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.CREATE_CASE_STUDY_FAILURE, error } }
}

function updateCaseStudy(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateCaseStudy(data)
            .then(
                dashboard => {
                    toast("Case Study Updated!")
                    dispatch(this.getCaseStudyList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_CASE_STUDY_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_CASE_STUDY_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_CASE_STUDY_FAILURE, error } }
}


function deleteCaseStudy(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.deleteCaseStudy(data)
            .then(
                dashboard => {
                    toast("Case Study Deleted!")
                    dispatch(this.getCaseStudyList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.DELETE_CASE_STUDY_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.DELETE_CASE_STUDY_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.DELETE_CASE_STUDY_FAILURE, error } }
}


function getCaseStudyList(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getCaseStudyList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard))
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_CASE_STUDY_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_CASE_STUDY_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_CASE_STUDY_LIST_FAILURE, error } }
}


function getCaseStudyDetailsList(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getCaseStudyDetailsList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard))
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_CASE_STUDY_DETAILS_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_CASE_STUDY_DETAILS_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_CASE_STUDY_DETAILS_LIST_FAILURE, error } }
}

function saveCaseStudyDetails(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveCaseStudyDetails(data)
            .then(
                dashboard => {
                    toast("Successfully Created!")
                    dispatch(this.getCaseStudyDetailsList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_CASE_STUDY_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_CASE_STUDY_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_CASE_STUDY_DETAILS_FAILURE, error } }
}

function updateCaseStudyDetails(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateCaseStudyDetails(data)
            .then(
                dashboard => {
                    toast("Successfully Updated!")
                    dispatch(this.getCaseStudyDetailsList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_CASE_STUDY_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_CASE_STUDY_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_CASE_STUDY_DETAILS_FAILURE, error } }
}




//Role Play-------------------------------------------------------------

function createRolePlay(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.createRolePlay(data)
            .then(
                dashboard => {
                    toast("Role Play Created!")
                    dispatch(this.getRolePlayList(temp));
                    dispatch(success(dashboard));
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.CREATE_ROLE_PLAY_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.CREATE_ROLE_PLAY_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.CREATE_ROLE_PLAY_FAILURE, error } }
}

function updateRolePlay(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateRolePlay(data)
            .then(
                dashboard => {
                    toast("Role Play Updated!")
                    dispatch(this.getRolePlayList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_ROLE_PLAY_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_ROLE_PLAY_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_ROLE_PLAY_FAILURE, error } }
}

function deleteRolePlay(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.deleteRolePlay(data)
            .then(
                dashboard => {
                    toast("Role Play Deleted!")
                    dispatch(this.getRolePlayList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.DELETE_ROLE_PLAY_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.DELETE_ROLE_PLAY_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.DELETE_ROLE_PLAY_FAILURE, error } }
}


function getRolePlayList(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getRolePlayList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard))
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_ROLE_PLAY_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_ROLE_PLAY_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_ROLE_PLAY_LIST_FAILURE, error } }
}


function getRolePlayDetailsList(data) {
    return dispatch => {
        dispatch(request());
        dashboardService.getRolePlayDetailsList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard))
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_ROLE_PLAY_DETAILS_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_ROLE_PLAY_DETAILS_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_ROLE_PLAY_DETAILS_LIST_FAILURE, error } }
}

function saveRolePlayDetails(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.saveRolePlayDetails(data)
            .then(
                dashboard => {
                    toast("Successfully Created!")
                    dispatch(this.getRolePlayDetailsList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.SAVE_ROLE_PLAY_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.SAVE_ROLE_PLAY_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.SAVE_ROLE_PLAY_DETAILS_FAILURE, error } }
}

function updateRolePlayDetails(data, temp) {
    return dispatch => {
        dispatch(request());
        dashboardService.updateRolePlayDetails(data)
            .then(
                dashboard => {
                    toast("Successfully Updated!")
                    dispatch(this.getRolePlayDetailsList(temp));
                    dispatch(success(dashboard))
                },
                error => {
                    toast("Failed!")
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.UPDATE_ROLE_PLAY_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.UPDATE_ROLE_PLAY_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.UPDATE_ROLE_PLAY_DETAILS_FAILURE, error } }
}


function getClientProfile(data) {
    let obj = {
        ClientProfileData: {}
    }
    return dispatch => {
        dispatch(success(obj));
        dispatch(request());
        dashboardService.getClientProfile(data)
            .then(
                dashboard => dispatch(success(dashboard)),
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_CLIENT_PROFILE_DATA_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_CLIENT_PROFILE_DATA_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_CLIENT_PROFILE_DATA_FAILURE, error } }
}




function getMetaRespondantDetails(data) {
    let obj = {
        getMetaRespondantDetailsData: []
    }
    return dispatch => {
        dispatch(success(obj));
        dispatch(request());
        dashboardService.getMetaRespondantDetails(data)
            .then(
                dashboard => dispatch(success(dashboard)),
                error => {

                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_META_RESPONDANT_DETAILS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_META_RESPONDANT_DETAILS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_META_RESPONDANT_DETAILS_FAILURE, error } }
}

function getResponseAnalytics(data) {
    let obj = {
        getResponseAnalyticsData: []
    }
    return dispatch => {
        dispatch(success(obj));
        dispatch(request());
        dashboardService.getResponseAnalytics(data)
            .then(
                dashboard => dispatch(success(dashboard)),
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_RESPONSE_ANALYTIYCS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_RESPONSE_ANALYTIYCS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_RESPONSE_ANALYTIYCS_FAILURE, error } }

}

function getMetaResponseAnalyticsFilter(data) {
    let obj = {
        getMetaResponseAnalyticsFilterData: []
    }
    return dispatch => {
        dispatch(success(obj));
        dispatch(request());
        dashboardService.getMetaResponseAnalyticsFilter(data)
            .then(
                dashboard => dispatch(success(dashboard)),
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_RESPONSE_META_ANALYTIYCS_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_RESPONSE_META_ANALYTIYCS_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_RESPONSE_META_ANALYTIYCS_FAILURE, error } }

}


function getEmpFilter() {
    let obj = {
        EmpFilterData: []
    }
    return dispatch => {
        dispatch(success(obj));
        dispatch(request());
        dashboardService.getEmpFilter()
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_EMP_FILTER_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_EMP_FILTER_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_EMP_FILTER_FAILURE, error } }
}


function getEmpSurveyWiseFilter(data) {
    let obj = {
        EmpFilterData: []
    }
    return dispatch => {
        dispatch(success(obj));
        dispatch(request());
        dashboardService.getEmpSurveyWiseFilter(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_EMP_FILTER_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_EMP_FILTER_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_EMP_FILTER_FAILURE, error } }
}


function getSurveyResponseList(data) {
    let obj = {
        EmpFilterData: []
    }
    return dispatch => {
        dispatch(success(obj));
        dispatch(request());
        dashboardService.getSurveyResponseList(data)
            .then(
                dashboard => {
                    dispatch(success(dashboard));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: dashboardConstants.GET_SURVEY_RESPONSE_LIST_REQUEST } }
    function success(dashboard) { return { type: dashboardConstants.GET_SURVEY_RESPONSE_LIST_SUCCESS, dashboard } }
    function failure(error) { return { type: dashboardConstants.GET_SURVEY_RESPONSE_LIST_FAILURE, error } }
}

